/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setActiveSelection } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import Background from 'material/embeds/content/shared/background/background';



/* ========== ~~~~~~~~~~ EMBED : BACKGROUND : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({

});


const mapDispatchToProps = dispatch => ({
    setActiveSelection: selection => dispatch(setActiveSelection(selection)),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Background);
